import React from 'react';

const InternalLinkComponent = ({ value, children }) => {
  const { slug = {}, type = '' } = value;

  if (type === 'help-center-article') {
    const href = `/help/articles/${slug.current}`;
    return <a href={href}>{children}</a>;
  } else if (type === 'help-center-category') {
    const href = `/help/${slug.current}`;
    return <a href={href}>{children}</a>;
  } else if (type === 'blog-article') {
    const href = `/blog/${slug.current}`;
    return <a href={href}>{children}</a>;
  } else if (type === 'blog-category') {
    const href = `/blog/topics/${slug.current}`;
    return <a href={href}>{children}</a>;
  } else {
    return children;
  }
};

export default InternalLinkComponent;
